export default __webpack_public_path__ + "1113a4d.png";